export default "__VITE_ASSET__Dgk3K$Jo__"